import "./SearchResultDebugInfo.scss";

import * as React from "react";

import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "shared/src/stores/storeConnect";
import { RelevanceJudgmentStore } from "../../../../../stores/RelevanceJudgmentStore";
import { simplifyScoreExplanation, ScoreCalculationNode } from "shared/src/scoreExplanationAnalysis";
import { SearchResultDebugInfo, SearchResultLtrDebugInfo } from "shared/src/types/articlesearch/SearchResult";

type ScoreExplanationPanelProps = {
    node: ScoreCalculationNode;
};

type ScoreExplanationPanelState = {
    expanded: boolean;
};

class ScoreExplanationPanel extends React.Component<ScoreExplanationPanelProps, ScoreExplanationPanelState> {
    constructor(props: ScoreExplanationPanelProps) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    _toggleExpanded = () => {
        this.setState({ expanded: !this.state.expanded });
    };

    render() {
        const niceDescription = this.props.node.niceDescription;
        const description = this.props.node.description;
        const className = this.props.node.match === false ? "no-match" : "";
        return (
            <div className={className}>
                {this.props.node.value}
                {this.props.node.value !== null && this.props.node.value !== undefined && " = "}
                {niceDescription}
                {description && !niceDescription && <pre>{description}</pre>}
                {this.props.node.details && (
                    <ul>
                        {this.props.node.details.map((node, i) => (
                            <li key={i}>
                                <ScoreExplanationPanel node={node} />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }
}

type Props = {
    debugInfo: SearchResultDebugInfo;
    ltrDebugInfo: SearchResultLtrDebugInfo | undefined | null;
    query: string | undefined | null;
    judgment: boolean | undefined | null;
    articleVariantId: string;
};

type State = {
    showScoreDialog: boolean;
};

export class DisconnectedSearchResultDebugInfoPanel extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            showScoreDialog: false
        };
    }

    _showScoreDialog = () => {
        this.setState({ showScoreDialog: true });
        return false;
    };

    _hideScoreDialog = () => {
        this.setState({ showScoreDialog: false });
        return false;
    };

    _renderLTRDebugInfo(): React.ReactNode {
        const features = this.props.ltrDebugInfo ? this.props.ltrDebugInfo.features : null;
        const score = this.props.ltrDebugInfo ? this.props.ltrDebugInfo.ltrScore : null;
        if (!features) return null;
        return (
            <div className={"sd-ltr-debug-info"}>
                <p>LTR model info</p>
                <p>
                    <b>LTR Score: </b>
                    {score ? score : null}
                </p>
                {Object.keys(features).map((key) => (
                    <ul key={key}>
                        <b>{key}</b>
                        <p>{features[key]}</p>
                    </ul>
                ))}
            </div>
        );
    }

    _renderScoreDialog(): React.ReactNode {
        return (
            <Modal show onHide={this._hideScoreDialog} className="sd-score-explanation-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Score explanation</Modal.Title>
                </Modal.Header>
                <Modal.Body className="container-fluid">
                    <ScoreExplanationPanel node={simplifyScoreExplanation(this.props.debugInfo.explain as any)} />
                    {this._renderLTRDebugInfo()}
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        const explanationText = (
            <p>
                This feedback will be used to improve the search results, but will not have any direct effect. Please
                only take into consideration the article itself, and not temporary aspects like promotions.
            </p>
        );

        // TODO(FD): I'd love to i18n this, but we currently wouldn't be able to apply the formatting then, and I think
        // that's important for readability :) and this stuff is not for the 'general public' anyway currently With a
        // more up-to-date react-intl, it would be possible:
        // https://github.com/formatjs/react-intl/blob/master/docs/Components.md#rich-text-formatting
        const relevanceUpvoteTooltip = (
            <Tooltip>
                <p>
                    This article is a <b>good</b> match for the search query '{this.props.query}'.
                </p>

                {explanationText}
            </Tooltip>
        );
        const relevanceDownvoteTooltip = (
            <Tooltip>
                <p>
                    This article is a <b>bad</b> match for the search query '{this.props.query}'.
                </p>

                {explanationText}
            </Tooltip>
        );
        const judgment = this.props.judgment;
        const judgmentExists = judgment !== undefined;
        return (
            <div className="sd-search-result-debug-info" style={{ order: 99 }}>
                <div style={{ fontSize: "70%", display: "inline-block" }}>
                    Score: {this.props.debugInfo.score}{" "}
                    <a
                        style={{ fontSize: "70%" }}
                        onClick={this._showScoreDialog}
                        className="test-search-result-debug-show">
                        (details)
                    </a>
                    <br />
                    Indexing time: {this.props.debugInfo.indexingTime}
                    <br />
                    {this.state.showScoreDialog && this._renderScoreDialog()}
                </div>
                <div style={{ float: "right" }}>
                    <OverlayTrigger placement="top" overlay={judgmentExists ? <span /> : relevanceUpvoteTooltip}>
                        <Button
                            className={(judgment === true ? "selected" : "") + " test-search-result-upvote"}
                            onClick={() => RelevanceJudgmentStore.postJudgment(this.props.articleVariantId, true)}
                            disabled={judgmentExists}>
                            👍
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={judgmentExists ? <span /> : relevanceDownvoteTooltip}>
                        <Button
                            className={(judgment === false ? "selected" : "") + " test-search-result-downvote"}
                            onClick={() => RelevanceJudgmentStore.postJudgment(this.props.articleVariantId, false)}
                            disabled={judgmentExists}>
                            👎
                        </Button>
                    </OverlayTrigger>
                </div>
            </div>
        );
    }
}

export const SearchResultDebugInfoPanel = connect(
    {
        stores: [
            [
                RelevanceJudgmentStore,
                (s: typeof RelevanceJudgmentStore, props: Props) => ({
                    query: s.getQuery(),
                    judgment: s.getJudgment(props.articleVariantId)
                })
            ]
        ]
    },
    DisconnectedSearchResultDebugInfoPanel
);
